import { ListItem } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import "./drawer-item.scss";

interface PropsFromParent {
  selected: boolean;
  icon?: JSX.Element;
  identifier: any;

  linkTo: string;
  text?: string;
  onMenuItemClicked: (identifier: string) => void;
}

export class DrawerItem extends React.PureComponent<PropsFromParent> {
  public render() {
    return (
      <Link to={this.props.linkTo} className="FireFoxDisable" >
        <ListItem
          alignItems="center"
          className="column"
          selected={this.props.selected}
          onClick={this.onMenuItemClicked}
          button={true}
          key={this.props.identifier}
        >
          {this.props.icon}
          <div className="deviceItemName">{this.props.text} </div>
        </ListItem>
      </Link>
    );
  }
  private onMenuItemClicked = () => {
    this.props.onMenuItemClicked(this.props.identifier);
  };
}
